// extracted by mini-css-extract-plugin
export var pulsingSpin = "faIcons-module--pulsingSpin--1dc4a";
export var spin = "faIcons-module--spin--9f3bf";